import { Tooltip } from '@mui/material'
import AnodisingIcon from '_icons/workingSteps/anodising-sm.svg?react'
import AssemblingIcon from '_icons/workingSteps/assembling-sm.svg?react'
import HemmingIcon from '_icons/workingSteps/bend-closed_sm.svg?react'
import BlastingIcon from '_icons/workingSteps/blasting-sm.svg?react'
import BoltPressingIcon from '_icons/workingSteps/bolt_pressing-sm.svg?react'
import CertifyIcon from '_icons/workingSteps/cf_certify_certify-sm.svg?react'
import DrawingIcon from '_icons/workingSteps/cf_draw_draw-sm.svg?react'
import TransportIcon from '_icons/workingSteps/cf_transport_transport-sm.svg?react'
import CleaningIcon from '_icons/workingSteps/cleaning_sm.svg?react'
import CounterSinkingIcon from '_icons/workingSteps/countersinking-sm.svg?react'
import DeburringIcon from '_icons/workingSteps/deburring-sm.svg?react'
import DieSinkingIcon from '_icons/workingSteps/die_sinking_sm.svg?react'
import DipCoatingIcon from '_icons/workingSteps/dip_coating_sm.svg?react'
import {
  default as DrillingIcon,
  default as ReamingIcon,
} from '_icons/workingSteps/drilling-sm.svg?react'
import EdgeMillingIcon from '_icons/workingSteps/edge_milling-sm.svg?react'
import EdgeTrimmingIcon from '_icons/workingSteps/edge_trimming-sm.svg?react'
import EngravingIcon from '_icons/workingSteps/engraving-sm.svg?react'
import FlowDrillingIcon from '_icons/workingSteps/flow_drilling_sm.svg?react'
import FoilingIcon from '_icons/workingSteps/foiling_sm.svg?react'
import FoldingIcon from '_icons/workingSteps/folding-sm.svg?react'
import HoleProtectioningIcon from '_icons/workingSteps/hole_protectioning_sm.svg?react'
import LevelTensioningIcon from '_icons/workingSteps/level_tensioning-sm.svg?react'
import MicroJointRemovalIcon from '_icons/workingSteps/micro_joint_removal_sm.svg?react'
import MillingIcon from '_icons/workingSteps/milling-sm.svg?react'
import NitridingIcon from '_icons/workingSteps/nitriding_sm.svg?react'
import NutPressingIcon from '_icons/workingSteps/nut_pressing-sm.svg?react'
import OperatingIcon from '_icons/workingSteps/operating_sm.svg?react'
import OrbitalSandingIcon from '_icons/workingSteps/orbital sanding_sm.svg?react'
import OrderPickingIcon from '_icons/workingSteps/order_picking-sm.svg?react'
import PackagingIcon from '_icons/workingSteps/packaging-sm.svg?react'
import PicklingPassivatingIcon from '_icons/workingSteps/pickling_passivating-sm.svg?react'
import PlateCuttingIcon from '_icons/workingSteps/plate_cutting-sm.svg?react'
import PlateShearingIcon from '_icons/workingSteps/plate_shearing-sm.svg?react'
import PolishingIcon from '_icons/workingSteps/polishing-sm.svg?react'
import PowderCoatingIcon from '_icons/workingSteps/powder_coating-sm.svg?react'
import PrimingIcon from '_icons/workingSteps/priming_sm.svg?react'
import ProgrammingIcon from '_icons/workingSteps/programming-sm.svg?react'
import PrototypingIcon from '_icons/workingSteps/prototyping_sm.svg?react'
import PunchingIcon from '_icons/workingSteps/punching-sm.svg?react'
import PurchasingIcon from '_icons/workingSteps/purchasing-sm.svg?react'
import QualityControllingIcon from '_icons/workingSteps/quality_controlling_sm.svg?react'
import RedLeadPrimingIcon from '_icons/workingSteps/red_lead_priming_sm.svg?react'
import ResearchingIcon from '_icons/workingSteps/researching_sm.svg?react'
import RivetingIcon from '_icons/workingSteps/riveting_sm.svg?react'
import RobotStudWeldingIcon from '_icons/workingSteps/robot_stud_welding_sm.svg?react'
import RobotWeldingIcon from '_icons/workingSteps/robot_welding_sm.svg?react'
import RollingIcon from '_icons/workingSteps/rolling-sm.svg?react'
import {
  default as Sawing3dIcon,
  default as SawingIcon,
} from '_icons/workingSteps/sawing-sm.svg?react'
import StudWeldingIcon from '_icons/workingSteps/stud_welding-sm.svg?react'
import ThreadTappingIcon from '_icons/workingSteps/thread_tapping-sm.svg?react'
import ToolingIcon from '_icons/workingSteps/tooling_sm.svg?react'
import TubeBendingIcon from '_icons/workingSteps/tube_bending-sm.svg?react'
import TubeOrProfileCuttingIcon from '_icons/workingSteps/tube_or_profile_cutting-sm.svg?react'
import TuringIcon from '_icons/workingSteps/turning-sm.svg?react'
import UndefinedIcon from '_icons/workingSteps/undefined-sm.svg?react'
import VibratoryDeburringIcon from '_icons/workingSteps/vibratory_deburring_sm.svg?react'
import WeldGrindingIcon from '_icons/workingSteps/weld-grinding-sm.svg?react'
import WeldingIcon from '_icons/workingSteps/welding-sm.svg?react'
import WeldingFixtureIcon from '_icons/workingSteps/welding_fixture_sm.svg?react'
import WetPaintingIcon from '_icons/workingSteps/wet_painting_sm.svg?react'
import WireErosionIcon from '_icons/workingSteps/wire_erosion_sm.svg?react'
import {
  default as NickelPlatingIcon,
  default as ZincPlatingIcon,
} from '_icons/workingSteps/zinc_plating-sm.svg?react'
import { useLocalizedWorkingStepLabel } from 'components/Localization/useLocalizedWorkingStepLabel'
import React, { HTMLProps } from 'react'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'

type WorkingStepIconSvgProps = {
  workingStepType: WorkingStepType
  attributes?: React.SVGProps<SVGSVGElement>
  disableTitle?: boolean
  title?: string
  className?: string
  disableTooltip?: boolean
  svgProps?: HTMLProps<SVGSVGElement>
}

const WorkingStepIconsMap: Record<
  WorkingStepType,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  [WorkingStepType.SheetCutting]: PlateCuttingIcon,
  [WorkingStepType.Sawing]: SawingIcon,
  [WorkingStepType.SheetBending]: FoldingIcon,
  [WorkingStepType.CounterSinking]: CounterSinkingIcon,
  [WorkingStepType.Milling]: MillingIcon,
  [WorkingStepType.TubeOrProfileCutting]: TubeOrProfileCuttingIcon,
  [WorkingStepType.Turning]: TuringIcon,
  [WorkingStepType.Purchasing]: PurchasingIcon,
  [WorkingStepType.Engraving]: EngravingIcon,
  [WorkingStepType.ThreadTapping]: ThreadTappingIcon,
  [WorkingStepType.Anodising]: AnodisingIcon,
  [WorkingStepType.Assembling]: AssemblingIcon,
  [WorkingStepType.BoltPressing]: BoltPressingIcon,
  [WorkingStepType.Deburring]: DeburringIcon,
  [WorkingStepType.Drilling]: DrillingIcon,
  [WorkingStepType.EdgeMilling]: EdgeMillingIcon,
  [WorkingStepType.EdgeTrimming]: EdgeTrimmingIcon,
  [WorkingStepType.LevelTensioning]: LevelTensioningIcon,
  [WorkingStepType.NutPressing]: NutPressingIcon,
  [WorkingStepType.PicklingPassivating]: PicklingPassivatingIcon,
  [WorkingStepType.SheetShearing]: PlateShearingIcon,
  [WorkingStepType.Polishing]: PolishingIcon,
  [WorkingStepType.ElectrolyticPolishing]: PolishingIcon,
  [WorkingStepType.PowderCoating]: PowderCoatingIcon,
  [WorkingStepType.Punching]: PunchingIcon,
  [WorkingStepType.Rolling]: RollingIcon,
  [WorkingStepType.StudWelding]: StudWeldingIcon,
  [WorkingStepType.TubeProfileOrBarBending]: TubeBendingIcon,
  [WorkingStepType.Welding]: WeldingIcon,
  [WorkingStepType.ZincPlating]: ZincPlatingIcon,
  [WorkingStepType.ZincPlatingBarrel]: ZincPlatingIcon,
  [WorkingStepType.ZincPlatingRack]: ZincPlatingIcon,
  [WorkingStepType.Designing]: DrawingIcon,
  [WorkingStepType.Certifying]: CertifyIcon,
  [WorkingStepType.Shipping]: TransportIcon,
  [WorkingStepType.Programming]: ProgrammingIcon,
  [WorkingStepType.OrderPicking]: OrderPickingIcon,
  [WorkingStepType.Packaging]: PackagingIcon,
  [WorkingStepType.BeadBlasting]: BlastingIcon,
  [WorkingStepType.SandBlasting]: BlastingIcon,
  [WorkingStepType.SteelGridBlasting]: BlastingIcon,
  [WorkingStepType.WetBlasting]: BlastingIcon,
  [WorkingStepType.VacuumBlasting]: BlastingIcon,
  [WorkingStepType.CentrifugalBlasting]: BlastingIcon,
  [WorkingStepType.SodaBlasting]: BlastingIcon,
  [WorkingStepType.BristleBlasting]: BlastingIcon,
  [WorkingStepType.DryIceBlasting]: BlastingIcon,
  [WorkingStepType.PencilBlasting]: BlastingIcon,
  [WorkingStepType.WeldGrinding]: WeldGrindingIcon,
  [WorkingStepType.DieSinking]: DieSinkingIcon,
  [WorkingStepType.Nitriding]: NitridingIcon,
  [WorkingStepType.RobotStudWelding]: RobotStudWeldingIcon,
  [WorkingStepType.RobotWelding]: RobotWeldingIcon,
  [WorkingStepType.WireErosion]: WireErosionIcon,
  [WorkingStepType.Hemming]: HemmingIcon,
  [WorkingStepType.Cleaning]: CleaningIcon,
  [WorkingStepType.CathodicDipCoating]: DipCoatingIcon,
  [WorkingStepType.ElectrophoreticDipCoating]: DipCoatingIcon,
  [WorkingStepType.FlowDrilling]: FlowDrillingIcon,
  [WorkingStepType.Foiling]: FoilingIcon,
  [WorkingStepType.HoleProtectioning]: HoleProtectioningIcon,
  [WorkingStepType.Operating]: OperatingIcon,
  [WorkingStepType.QualityControlling]: QualityControllingIcon,
  [WorkingStepType.Researching]: ResearchingIcon,
  [WorkingStepType.VibratoryDeburring]: VibratoryDeburringIcon,
  [WorkingStepType.Sawing3d]: Sawing3dIcon,
  [WorkingStepType.NickelPlating]: NickelPlatingIcon,
  [WorkingStepType.Loading]: UndefinedIcon,
  [WorkingStepType.Unloading]: UndefinedIcon,
  [WorkingStepType.NotInitialized]: UndefinedIcon,
  [WorkingStepType.Setup]: UndefinedIcon,
  [WorkingStepType.WetPainting]: WetPaintingIcon,
  [WorkingStepType.MicroJointRemoval]: MicroJointRemovalIcon,
  [WorkingStepType.Reaming]: ReamingIcon,
  [WorkingStepType.Riveting]: RivetingIcon,
  [WorkingStepType.OrbitalSanding]: OrbitalSandingIcon,
  [WorkingStepType.RedLeadPriming]: RedLeadPrimingIcon,
  [WorkingStepType.Tooling]: ToolingIcon,
  [WorkingStepType.WeldingFixture]: WeldingFixtureIcon,
  [WorkingStepType.Prototyping]: PrototypingIcon,
  [WorkingStepType.Priming]: PrimingIcon,
}

const WorkingStepIconSvg = React.forwardRef(
  (props: WorkingStepIconSvgProps, ref: React.Ref<SVGSVGElement>) => {
    const getLocalizedWorkingStep = useLocalizedWorkingStepLabel()

    const svgTitle = props.title
      ? props.title
      : !props.disableTitle
        ? getLocalizedWorkingStep(props.workingStepType)
        : undefined

    const SvgComponent =
      WorkingStepIconsMap[props.workingStepType] || UndefinedIcon

    if (SvgComponent === UndefinedIcon) {
      return <div style={{ width: props.attributes?.width || '32px' }} />
    }

    if (props.disableTooltip) {
      return (
        <SvgComponent
          {...(props.attributes || {})}
          {...(props.svgProps || {})}
          className={`icon ${props.className || ''}`}
          ref={ref}
        />
      )
    } else {
      return (
        <Tooltip title={svgTitle} placement="left">
          <span>
            <SvgComponent
              {...props.attributes}
              className={`icon ${props.className || ''}`}
              ref={ref}
            />
          </span>
        </Tooltip>
      )
    }
  },
)

WorkingStepIconSvg.displayName = 'WorkingStepIconSvg'

export { WorkingStepIconSvg }
